<img
  src="../../../../assets/icons/add-frame.svg"
  alt="no icon"
  class="icon"
  [ngClass]="{ disabled: !canUpdate }"
  (click)="setFrameToSelectedArea()"
/>
